import React, { useRef, useEffect } from "react";
import animationData from "./animation_data";
import Lottie from "lottie-react";

interface LottieAnimationProps {
  width?: number | string;
  height?: number | string;
}

const LoadingAnimation: React.FC<LottieAnimationProps> = ({
  width = "100%",
  height = "100%",
}) => (
  <Lottie
    animationData={animationData}
    width={width}
    height={height}
    loop={true}
  />
);
export default LoadingAnimation;
